import { Typography } from "@material-ui/core"
import { useContext } from "react"
import { AppContext } from "../../providers/app-context-provider/app.context"
import ProductEnum from "../../utils/product-enum"
import JuristtaSchoolWrittenGuide from "./juristta-school-written-guide"
import JuristtaQuizWrittenGuide from "./juristta-quiz-written-guide"


const JuristtaWrittenGuide = () => {

    const context = useContext(AppContext)
    const current_product_id = context.product?.id

    if (current_product_id === ProductEnum.SCHOOL) {
        return <JuristtaSchoolWrittenGuide />
    } else if (current_product_id === ProductEnum.QUIZ) {
        return <JuristtaQuizWrittenGuide />
    } else {
        return <Typography>{'Guia escrito para este produto está em desenvolvimento.'}</Typography>
    }

}

export default JuristtaWrittenGuide